import React, { useState } from 'react';
const MeasurementDropdown = ({name, mvalue, changeHandle, min, max}) => {
      
 const handleChange = (e)=>{
            let name = e.target.name;
            let value = e.target.value;
            changeHandle(name, value);
        }

  const m_number = [];
  for(var i=min; i<=max; i=i+0.5){  m_number.push(i); }
  
  return (
    <>
        {m_number && (
          <select name={name} defaultValue={''} value={mvalue} onChange={handleChange}>
            <option value="">In Inches</option>
            {m_number.map((e,i)=>( 
                <option value={e} key={i}>{e}</option>
            ))}
          </select>
        )}
    </>
  )
}

export default MeasurementDropdown
